import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { useSelector, useDispatch } from 'react-redux';
import { hideLogDialog } from '../../redux/actions/dialogActions.js';
import {
  clearDate,
  setComment,
  setDate,
  setStage,
  clearStage,
  setHour,
  setModule,
  clearModule,
  setTask,
  setWpl,
  setModType,
  clearModType,
} from '../../redux/actions/logActions.js';
import { dictionary } from '../../dictionary.js';
import DialogOverlay from './DialogOverlay.js';

const LogisticsComponent = (props) => {
  const dispatch = useDispatch();
  const dialogProps = props.dialogProps;
  const dateLog = new Date(useSelector((state) => state.date.value));
  const moduleLog = useSelector((state) => state.module.value);
  const modTypeLog = useSelector((state) => state.modType.value);
  const stageLog = useSelector((state) => state.stage.value);
  const hourLog = useSelector((state) => state.hours.value);
  const wplLog = useSelector((state) => state.wpl.value);
  const commentLog = useSelector((state) => state.comment.value);
  const taskLog = useSelector((state) => state.task.value);
  const [logisticSorted, setLogisticSorted] = useState(null);
  const [blAlSorted, setBlAlSorted] = useState(null);
  const toast = useRef(null);

  useEffect(() => {
    if (dialogProps.eldData[0].length !== 0) {
      setLogisticSorted(dialogProps.sortData(dialogProps.eldData[0].logistics));
      setBlAlSorted(dialogProps.sortData(dialogProps.eldData[0].int[0].blal));
    }
  }, [dialogProps]);

  const showMsg = () => {
    toast.current.show({
      severity: 'warn',
      summary: dictionary.toast_summary_warn,
      detail: dictionary.toast_create_log_detail,
      life: 7000,
    });
  };

  const resetIntButtons = () => {
    dispatch(clearModule());
    dispatch(clearStage());
    dispatch(clearModType());
  };

  return (
    <>
      <Dialog
        header={dictionary.log_dialog_header}
        visible={dialogProps.isDialogOpen}
        style={{ width: '50vw' }}
        onHide={() => {
          dialogProps.setValuesOnInitialState();
          dialogProps.setShowOverlay(true);
          dispatch(hideLogDialog());
        }}
      >
        <div className="field field-wrapper">
          <Toast ref={toast} />
          <label>{dictionary.dialog_label_date}</label>
          {dialogProps.showOverlay && <DialogOverlay dialogProps={dialogProps} />}
          <Calendar
            disabledDays={dialogProps.disabledDays}
            style={{ width: '100%' }}
            placeholder={dateLog}
            value={dateLog}
            onChange={(e) => {
              if (dialogProps.checkIfDayIsPlanned(e.value)) {
                dispatch(setDate(e.value));
                dialogProps.setShowOverlay(false);
              } else {
                showMsg();
                dispatch(clearDate());
              }
            }}
            showIcon
            dateFormat="dd/mm/yy"
          />
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_module_types}</label>
          <div className="row">
            <div className="col">
              <Button
                className="buttons"
                label={dictionary.dialog_button_label20}
                onClick={() => {
                  resetIntButtons();
                  dispatch(setModType('BL/AL'));
                }}
              />
            </div>
            <div className="col">
              <Button
                className="buttons"
                label={dictionary.other_btn_label}
                onClick={() => {
                  resetIntButtons();
                }}
              />
            </div>
          </div>
        </div>
        <div className="field field-wrapper">
          {modTypeLog !== null && modTypeLog === 'BL/AL' ? (
            <>
              <label>{dictionary.dialog_button_label20}</label>
              <Dropdown
                style={{ width: '100%' }}
                value={moduleLog}
                options={blAlSorted}
                filter
                filterInputAutoFocus
                onChange={(e) => {
                  dispatch(setModule(e.value.name));
                }}
                optionLabel="name"
                placeholder={moduleLog !== null ? moduleLog : dictionary.dialog_placeholder_module}
                className={moduleLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
              />
            </>
          ) : (
            <>
              <label>{dictionary.dialog_label_module}</label>
              <Dropdown
                style={{ width: '100%' }}
                value={moduleLog}
                options={logisticSorted}
                filter
                filterInputAutoFocus
                onChange={(e) => {
                  dispatch(setModule(e.value.name));
                }}
                optionLabel="name"
                placeholder={moduleLog !== null ? moduleLog : dictionary.dialog_placeholder_module}
                className={moduleLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
              />
            </>
          )}
          {moduleLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_module}</small>
          ) : null}
          {moduleLog === 'Drobne_projekty' ? (
            <>
              <Dropdown
                style={{ width: '100%', marginTop: '0.5rem' }}
                value={taskLog}
                options={dialogProps.eldData[0].projects_logistics.sort((a, b) => a.name.localeCompare(b.name))}
                filter
                filterInputAutoFocus
                onChange={(e) => {
                  dispatch(setTask(e.value.name));
                }}
                optionLabel="name"
                placeholder={taskLog !== null ? taskLog : dictionary.dialog_placeholder_task}
                className={taskLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
              />
              {taskLog === null && dialogProps.formSubmitted ? (
                <small className="p-error">{dictionary.dialog_error_task}</small>
              ) : null}
            </>
          ) : null}
          {moduleLog !== 'Hour management' ? (
            <>
              <>
                <label>{dictionary.dialog_label_stage}</label>
                <Dropdown
                  style={{ width: '100%' }}
                  value={stageLog}
                  options={dialogProps.eldData[0].stages_development}
                  filter
                  filterInputAutoFocus
                  onChange={(e) => {
                    dispatch(setStage(e.value.name));
                  }}
                  optionLabel="name"
                  placeholder={stageLog !== null ? stageLog : dictionary.dialog_placeholder_stage}
                  className={stageLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
                />
                {stageLog === null && dialogProps.formSubmitted ? (
                  <small className="p-error">{dictionary.dialog_error_stage}</small>
                ) : null}
              </>
            </>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_hours}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={hourLog}
            options={dialogProps.eldData[0].hours}
            filter
            filterInputAutoFocus
            onChange={(e) => {
              dispatch(setHour(e.value.hour));
            }}
            optionLabel="hour"
            placeholder={
              hourLog !== null && hourLog !== undefined ? String(hourLog) : dictionary.dialog_placeholder_hours
            }
            className={(hourLog === null || hourLog === undefined) && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {(hourLog === null || hourLog === undefined) && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_hours}</small>
          ) : null}
        </div>
        {dialogProps.postEditing ? (
          <div className="field field-wrapper">
            <label>{dictionary.dialog_label_wpl}</label>
            <Dropdown
              style={{ width: '100%' }}
              value={wplLog}
              options={dialogProps.wplArr}
              onChange={(e) => {
                dispatch(setWpl(e.value.name));
              }}
              optionLabel="name"
              placeholder={wplLog !== 0 ? wplLog : dictionary.dialog_placeholder_wpl}
              className={wplLog === 0 && dialogProps.formSubmitted ? 'p-invalid' : null}
            />
            {wplLog === 0 && dialogProps.formSubmitted ? (
              <small className="p-error">{dictionary.dialog_error_wpl}</small>
            ) : null}
          </div>
        ) : null}
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_comment}</label>
          <InputText
            style={{ width: '100%' }}
            value={commentLog !== null ? commentLog : ''}
            placeholder={dictionary.dialog_placeholder_comment}
            onChange={(e) => {
              dispatch(setComment(e.target.value));
            }}
          />
        </div>
        <div className="field field-wrapper">
          {!dialogProps.postEditing ? (
            <Button
              label={dictionary.dialog_save_btn}
              icon="pi pi-save"
              className="field-report-btn"
              onClick={() => {
                dialogProps.setFormSubbmited(true);
                dialogProps.setShowOverlay(true);
                const isValidHour = hourLog !== null && hourLog !== undefined;
                if (moduleLog !== null && stageLog !== null && isValidHour) {
                  dialogProps.onLogSave();
                } else if (moduleLog === 'Drobne_projekty' && taskLog !== null && isValidHour) {
                  dialogProps.onLogSave();
                } else if (moduleLog === 'Hour management' && isValidHour) {
                  dialogProps.onLogSave();
                }
              }}
            />
          ) : (
            <Button
              label={dictionary.dialog_update_btn}
              icon="pi pi-save"
              className="field-report-btn"
              onClick={() => {
                dialogProps.setFormSubbmited(true);
                dialogProps.setShowOverlay(true);
                const isValidHour = hourLog !== null && hourLog !== undefined;
                if (moduleLog !== null && stageLog !== null && isValidHour) {
                  dialogProps.onRowEditComplete();
                } else if (moduleLog === 'Drobne_projekty' && taskLog !== null && isValidHour) {
                  dialogProps.onRowEditComplete();
                } else if (moduleLog === 'Hour management' && isValidHour) {
                  dialogProps.onRowEditComplete();
                }
              }}
            />
          )}
        </div>
      </Dialog>
    </>
  );
};

export default LogisticsComponent;
